import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import { useAppContext } from './context/AppContext.js';
import Header from './components/Header.js';
import Title from './components/Title.js';
import Button from './components/Button.js';
import ErrorBox from './components/ErrorBox.js';
import IconLogo from './components/icons/IconLogo.js';
import IconError from './components/icons/IconError.js';
import IconBusinessUnit from './components/icons/IconBusinessUnit.js';
import IconCurrency from './components/icons/IconCurrency.js';
import IconOperationType from './components/icons/IconOperationType.js';
import IconSegment from './components/icons/IconSegment.js';
import IconSubCategory from './components/icons/IconSubCategory.js';
import IconSuperitem from './components/icons/IconSuperitem.js';
import IconBranch from './components/icons/IconBranch.js';
import IconUsersMonitor from './components/icons/IconUsersMonitor.js';
import IconUser from './components/icons/IconUser.js';
import NotFound from './pages/not-found/NotFound.js';
import Branches from './pages/branches/Branches.js';
import BudgetCapital from './pages/budget-capital/BudgetCapital.js';
import BudgetOperation from './pages/budget-operation/BudgetOperation.js';
import BusinessUnits from './pages/business-units/BusinessUnits.js';
import Currencies from './pages/currencies/Currencies.js';
import Home from './pages/home/Home.js';
import OperationTypes from './pages/operation-types/OperationTypes.js';
import Segments from './pages/segments/Segments.js';
import SubCategories from './pages/sub-categories/SubCategories.js';
import Superitems from './pages/superitems/Superitems.js';
import User from './pages/user/User.js';
import Users from './pages/users/Users.js';
import UsersMonitor from './pages/users-monitor/UsersMonitor.js';
import SecurityService from './services/SecurityService.js';
import { getWords } from './utils/get-words.js';

const App = ReactRouterDOM.withRouter(function () {
  const { i18n, error, setError } = useAppContext();

  const words = getWords(i18n.code);

  const header = (
    <Header
      icon={IconLogo}
      label={words.budgetManagement}
      languages={[
        {
          code: 'Sp',
          name: words.spanish,
          dateFormat: 'dd/mm/yyyy',
          moneySymbol: '$'
        }
      ]}
      menu={[
        {
          label: words.administration,
          options: [
            { icon: IconBusinessUnit, label: words.businessUnits, path: "/business-units", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconCurrency, label: words.currencies, path: "/currencies", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconOperationType, label: words.operationTypes, path: "/operation-types", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconSegment, label: words.segments, path: "/segments", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconSubCategory, label: words.subCategories, path: "/sub-categories", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconSuperitem, label: words.superitems, path: "/superitems", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator'))) },
            { icon: IconBranch, label: words.branches, path: "/branches", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator'))) },
          ]
        },
        {
          label: words.dashboards,
          options: [
            { icon: IconUsersMonitor, label: words.usersMonitor, path: "/users-monitor", hidden: !((SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer'))) },
          ]
        },
        {
          label: words.security,
          options: [
            { icon: IconUser, label: words.users, path: "/users", hidden: !((SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator'))) },
          ]
        },
      ]}
    />
  );

  if (error === null || error === undefined || (error instanceof Response && (error.status === 400 || error.status === 409)) || (!(error instanceof Response))) {
    return (
      <div>
        {header}
        <ReactRouterDOM.Switch>
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/branches">
              <Branches />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? (
            <ReactRouterDOM.Route exact path="/budget-capital/:budgetCapitalId">
              <BudgetCapital />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? (
            <ReactRouterDOM.Route exact path="/budget-operation/:budgetOperationId">
              <BudgetOperation />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/business-units">
              <BusinessUnits />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/currencies">
              <Currencies />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? (
            <ReactRouterDOM.Route exact path="/">
              <Home />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/operation-types">
              <OperationTypes />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/segments">
              <Segments />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/sub-categories">
              <SubCategories />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/superitems">
              <Superitems />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/user/:userId">
              <User />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator')) ? (
            <ReactRouterDOM.Route exact path="/users">
              <Users />
            </ReactRouterDOM.Route>
          ) : null}
          {(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? (
            <ReactRouterDOM.Route exact path="/users-monitor">
              <UsersMonitor />
            </ReactRouterDOM.Route>
          ) : null}
          <ReactRouterDOM.Route>
            <NotFound />
          </ReactRouterDOM.Route>
        </ReactRouterDOM.Switch>
        {error ?
          <ReactBootstrap.Modal
            show={true}
            onHide={() => setError(null)}
            scrollable={true}
            centered={true}
          >
            <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
              <Title level={1} icon={IconError} color="red" label={words.error} />
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body className="p-0">
              <ErrorBox />
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer className="p-2">
              <Button label={words.close} color="blue" onClick={(e) => setError(null)} />
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal> :
          null
        }
      </div>
    );
  }
  else {
    return (
      <div>
        {header}
        <ErrorBox fullscreen={true} />
      </div>
    );
  }
})

export default App;
